import { GroupIds } from "@/configuration/group-ids";
import type { CustomerSmsRoutingConfig } from "@/customer-interface/sms-routing";
import { ENTP_LINE, ENTP_MOCK_LINE, ENTP_SMS_TRANSFER_LINE } from "@/shared/group-configs/groups";

export const ENT_PARTNERS_TWILIO_NUMBER = "+18884519992";

export const entpartnersSmsRoutingConfig = {
  groups: [
    {
      groupId: GroupIds.ENT_PARTNERS_LIVE,
      inboundPhoneNumbers: [ENTP_LINE, ENT_PARTNERS_TWILIO_NUMBER],
      defaultSenderPhoneNumber: ENT_PARTNERS_TWILIO_NUMBER,
      postCallSenderPhoneNumber: ENT_PARTNERS_TWILIO_NUMBER,
      clinicPhone: { defaultPhoneNumber: ENTP_SMS_TRANSFER_LINE, backupPhoneNumber: "+17732965500" },
    },
    {
      groupId: GroupIds.ENT_PARTNERS_LIVE_SANDBOX,
      inboundPhoneNumbers: [ENTP_MOCK_LINE],
      defaultSenderPhoneNumber: ENTP_MOCK_LINE,
      postCallSenderPhoneNumber: ENTP_MOCK_LINE,
      clinicPhone: { defaultPhoneNumber: ENTP_MOCK_LINE, backupPhoneNumber: "+17737886600" },
    },
  ],
} as const satisfies CustomerSmsRoutingConfig;
